import * as fromRouter from '@ngrx/router-store';
import { createFeatureSelector } from '@ngrx/store';

export interface State {
  router: fromRouter.RouterReducerState;
}

const selectRouter =
  createFeatureSelector<fromRouter.RouterReducerState>('router');

const {
  selectQueryParams, // select the current route query params
  selectQueryParam, // factory function to select a query param
  selectRouteParams, // select the current route params
  selectRouteParam, // factory function to select a route param
  selectRouteData, // select the current route data
  selectUrl, // select the current url
} = fromRouter.getRouterSelectors(selectRouter);

export const routerQuery = {
  getQueryParams: selectQueryParams,
  getQueryParam: selectQueryParam,
  getRouteParams: selectRouteParams,
  getRouteParam: selectRouteParam,
  getRouteData: selectRouteData,
  getUrl: selectUrl,
};
